"use client";

import { useEffect, type ReactNode } from "react";
import { I18nProvider, useI18n } from "@/lib/i18n/context";

function DirectionSetter({ children }: { children: ReactNode }) {
  const { locale, t, isHydrated } = useI18n();

  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = t.dir;
  }, [locale, t.dir]);

  if (!isHydrated) {
    return <div style={{ visibility: "hidden" }}>{children}</div>;
  }
  return <>{children}</>;
}

export function I18nRoot({ children }: { children: ReactNode }) {
  return (
    <I18nProvider>
      <DirectionSetter>{children}</DirectionSetter>
    </I18nProvider>
  );
}
